<dx-popup [(visible)]="visible" [title]="title" [showCloseButton]="true"
    [hideOnOutsideClick]="false" [shading]="true" shadingColor="rgba(0, 0, 0, 0.3)"
    [fullScreen]="fullScreen" (onHiding)="onPopupHiding()">
    <div class="multi-item-barcode-selection-wrapper">
        <dx-scroll-view width="100%" height="100%">
            <div class="multi-item-barcode-selection-list">
                <div *ngFor="let item of barcodeItems">
                    <ng-container>
                        <div class="multi-item-barcode-item" (click)="onItemClick(item)">
                            <div class="multi-item-barcode-item-content">
                                <div>
                                    <div class="name">
                                        {{item.AssociatedFactor.Stock.name}}
                                    </div>
                                    <div class="factor">
                                        {{ formatUnit(item) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </dx-scroll-view>
    </div>
</dx-popup>
